/**
 * MERIZME — Lüks tema iyileştirmeleri
 * - Header'a scroll'da .scrolled sınıfı ekler (glass blur efekti için)
 * - Scroll-linked fade-in (Intersection Observer)
 * - Görsellerde reveal davranışı
 */
(function () {
  'use strict';

  // — 1) Sticky header glass effect —
  let lastScroll = 0;
  let ticking = false;

  function updateScroll() {
    const y = window.scrollY;
    if (y > 60) {
      document.body.classList.add('scrolled');
    } else {
      document.body.classList.remove('scrolled');
    }
    // Aşağı doğru kaydırmada header'ı sakla, yukarı kaydırmada göster
    if (y > 200 && y > lastScroll) {
      document.body.classList.add('scrolling-down');
    } else {
      document.body.classList.remove('scrolling-down');
    }
    lastScroll = y;
    ticking = false;
  }

  window.addEventListener('scroll', () => {
    if (!ticking) {
      window.requestAnimationFrame(updateScroll);
      ticking = true;
    }
  }, { passive: true });

  // — 2) Bölümler için viewport reveal —
  if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.05 });

    // Bölüm seviyesi
    document.querySelectorAll('.section, [class*="section--"], .hero, .collection-list')
      .forEach((el) => io.observe(el));
  }

  // — 3) Detay: ana sayfa heading'lerine "elegance" ipucu —
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('h1, h2').forEach((h) => {
      // <em> taglerine yumuşak italik vurgu için ek class
      if (h.querySelector('em')) {
        h.classList.add('heading-italic');
      }
    });

    // — 4) Dil seçicisini şık custom dropdown'la değiştir —
    initCustomLanguageSelector();
  });

  /**
   * Native <select> dil seçicisini kendi custom dropdown'umuzla değiştir.
   * Native select hidden olur, click eventi yine onu trigger eder (form submit).
   */
  function initCustomLanguageSelector() {
    const selects = document.querySelectorAll(
      '.localization-form__select, .language-selector select, select#dropdownSelect'
    );

    selects.forEach((select) => {
      // Zaten dönüştürüldüyse atla
      if (select.dataset.merizmeEnhanced === 'true') return;
      select.dataset.merizmeEnhanced = 'true';

      const wrapper = document.createElement('div');
      wrapper.className = 'merizme-lang-dropdown';

      const trigger = document.createElement('button');
      trigger.type = 'button';
      trigger.className = 'merizme-lang-trigger';
      trigger.setAttribute('aria-haspopup', 'listbox');
      trigger.setAttribute('aria-expanded', 'false');

      const selectedOption = select.options[select.selectedIndex];
      const triggerLabel = document.createElement('span');
      triggerLabel.className = 'merizme-lang-label';
      triggerLabel.textContent = selectedOption ? selectedOption.textContent.trim() : 'Dil';

      const triggerIcon = document.createElement('span');
      triggerIcon.className = 'merizme-lang-icon';
      triggerIcon.innerHTML = '<svg width="10" height="10" viewBox="0 0 10 10" fill="none" aria-hidden="true"><path d="M2 4L5 7L8 4" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"/></svg>';

      trigger.appendChild(triggerLabel);
      trigger.appendChild(triggerIcon);

      const list = document.createElement('ul');
      list.className = 'merizme-lang-list';
      list.setAttribute('role', 'listbox');
      list.hidden = true;

      Array.from(select.options).forEach((option, idx) => {
        const li = document.createElement('li');
        li.className = 'merizme-lang-option';
        li.setAttribute('role', 'option');
        li.dataset.value = option.value;
        li.textContent = option.textContent.trim();
        if (idx === select.selectedIndex) {
          li.setAttribute('aria-selected', 'true');
        }

        li.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          if (select.value === option.value) {
            close();
            return;
          }
          select.value = option.value;
          // Native change eventi tetikle (Shopify bunu dinliyor → form submit eder)
          const ev = new Event('change', { bubbles: true });
          select.dispatchEvent(ev);
          // Form submit fallback
          const form = select.closest('form');
          if (form && typeof form.requestSubmit === 'function') {
            form.requestSubmit();
          } else if (form) {
            form.submit();
          }
        });
        list.appendChild(li);
      });

      wrapper.appendChild(trigger);
      wrapper.appendChild(list);

      // Native select'i gizle, custom UI'yi yanına ekle
      select.style.display = 'none';
      select.parentNode.insertBefore(wrapper, select);

      function open() {
        list.hidden = false;
        trigger.setAttribute('aria-expanded', 'true');
        wrapper.classList.add('is-open');
        document.addEventListener('click', onOutsideClick);
        document.addEventListener('keydown', onKey);
      }
      function close() {
        list.hidden = true;
        trigger.setAttribute('aria-expanded', 'false');
        wrapper.classList.remove('is-open');
        document.removeEventListener('click', onOutsideClick);
        document.removeEventListener('keydown', onKey);
      }
      function onOutsideClick(e) {
        if (!wrapper.contains(e.target)) close();
      }
      function onKey(e) {
        if (e.key === 'Escape') close();
      }

      trigger.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (list.hidden) open();
        else close();
      });
    });
  }

})();